module.exports = __webpack_public_path__ + "static/media/ic_man.0cb1bb36.svg";